import iconTemplate from './IconTemplate.jsx';

export default iconTemplate(
    <svg
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 14 14"
        id="Input-Box--Streamline-Flex"
    >
        <desc>{'Input Box Streamline Icon: https://streamlinehq.com'}</desc>
        <g id="input-box--cursor-text-formatting-type-format">
            <path
                id="Vector"
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M7.64551 4.60278c1.37421 0.00294 2.53409 0.06057 4.49239 0.20199 0.6704 0.04841 1.2407 0.53799 1.3131 1.20616 0.0713 0.65886 0.0638 1.24973 -0.0143 1.94584 -0.0748 0.66643 -0.6251 1.17122 -1.2922 1.23949 -1.8354 0.18783 -2.75869 0.24376 -4.49899 0.16234"
                strokeWidth={1}
            />
            <path
                id="Vector_2"
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M2.38232 4.74933c-0.16751 0.01618 -0.34247 0.0337 -0.5266 0.05254 -0.66712 0.06827 -1.217422 0.57307 -1.292196 1.23949C0.485419 6.73748 0.477903 7.32834 0.54922 7.9872c0.072325 0.66818 0.64233 1.15772 1.31266 1.20613 0.17996 0.013 0.35318 0.02529 0.52044 0.03689"
                strokeWidth={1}
            />
            <path
                id="Vector_3"
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M3.97998 1.5645c0.93917 -0.08984 1.46783 -0.08541 2.40689 0"
                strokeWidth={1}
            />
            <path
                id="Vector_4"
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M3.97998 12.3958c0.96253 0.141 1.49053 0.1333 2.40689 0"
                strokeWidth={1}
            />
            <path
                id="Vector_5"
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M5.18386 1.5647c-0.17753 4.266 -0.19533 6.64839 0 10.831"
                strokeWidth={1}
            />
        </g>
    </svg>,
);
